/**
 * @description 如果是开发或测试环境，则加上devtool工具（eruda），帮助手机调试
 * @param {RegExp[]} extraDevHostsReg 额外自定义的开发环境host地址，类型为正则数组，如：[ /^[a-z]+-beta\d\.duitang\.com/ ]
 * @return {boolean} true表示符合devtool添加条件，false表示不符合
 */
const useDevTool = (extraDevHostsReg?: RegExp[]): boolean => {
  const DEV_TOOL_ID = 'tool-unique-symbol';
  const _devHostsReg = [
    /^[a-z]+-beta\d\.duitang\.com/,
    /^[a-z]+-t\d+\.duitang\.net/,
    /^dev\.duitang\.net/,
    /^localhost/,
    /^0\.0\.0\.0/,
    /^127\.0\.0\.1/,
    ...(extraDevHostsReg || []),
  ];
  function isDevHost() {
    return _devHostsReg.some(devHostReg => devHostReg.test(window.location.host));
  }
  function hasAddingDevTool() {
    const target = document.querySelector(`#${DEV_TOOL_ID}`);
    return !!target;
  }
  if (isDevHost() && !hasAddingDevTool()) {
    // 测试环境 打开 eruda 调试
    const script = document.createElement('script');
    script.setAttribute('id', DEV_TOOL_ID);
    script.src = 'https://dt-static.s3.cn-east-2.jdcloud-oss.com/static/eruda.js';
    document.head.appendChild(script);
    script.onload = function () {
      (window as any).eruda.init();
    };
    return true;
  } else {
    return false;
  }
};

export default useDevTool;
